declare const Highcharts;

/**
 * FundAnalyticsLineChartTooltip: this tooltip is the line chart tooltip used by Fund Analytics
 */
export class FundAnalyticsLineChartTooltip {
	public static getFormatter(): Function {
		return function (): string {
			return `
			<div style="width: 200px" class="rolling-tooltip-container">
				<div class="tooltip-body">
					<table style="width: 200px">
					<tr>
						<td><div class="text-12 text-bold">${Highcharts.dateFormat('%m/%Y', this.x)}</div></td>
						<td style="text-align:right">${Highcharts.numberFormat(this.y, 2, '.', ',')}%</td>
					</tr>
					</table>
				</div>
			</div>`;
		};
	}
}
